import React from 'react'
import PropTypes from 'prop-types'

const HelpButton = ({ classNameAppend, onClick }) => {

  const defaultCss = 'rounded-full min-w-6 h-6 bg-sky flex items-end leading-normal justify-center text-white text-sm font-bold'
  const className = `${defaultCss} ${classNameAppend}`
  return (
    <button
      onClick={onClick}
      type="button"
      className={className}
    >
      i
    </button>
  )
}

HelpButton.propTypes = {
  classNameAppend: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

HelpButton.defaultProps = {
  classNameAppend: ''
}

export default HelpButton